import React from 'react';
import Flex from '../../../../components/layout/flex';
import Avatar from '../../../../components/basics/avatar';
import { getDealAvatar } from '../parsers/get-deal-avatar';
import { Deal } from '@services/deals/types/deal';

interface DealNameProps {
  deal: Deal;
}

export const DealName: React.FC<DealNameProps> = ({ deal }) => {
  return (
    <Flex alignItems='center' gap={10}><Avatar src={getDealAvatar(deal)} /> {deal.notes}</Flex>
  )
}